module.exports = __webpack_public_path__ + "img/TMCvsGC.8fe7d7da.png";